import _ from 'lodash';

import PageElementMetaData from 'crazyEditor/components/Elements/PageElement/PageElementMetaData';
import BackgroundElementMetaData from 'crazyEditor/components/Elements/BackgroundElement/BackgroundElementMetaData';

export const PAGE_ELEMENT_ID = PageElementMetaData.id;
export const BACKGROUND_ELEMENT_ID = BackgroundElementMetaData.id;

export function getPageElement(elements) {
  return elements[PAGE_ELEMENT_ID];
}

export function getBackgroundElement(elements) {
  return elements[BACKGROUND_ELEMENT_ID];
}

export function isPageElement(elementId) {
  return elementId === PAGE_ELEMENT_ID;
}

export function isBackgroundElement(elementId) {
  return elementId === BACKGROUND_ELEMENT_ID;
}

export function isStaticElement(elementId) {
  return isPageElement(elementId) || isBackgroundElement(elementId);
}

export function omitStaticElementsAndHiddenElements(elements) {
  return _.filter(elements, (element) => !isStaticElement(element.id) && !element.hidden);
}

